import { useGetLevelItemSubtreeByQConfigStructureQuery } from '@exam-management/graphql';
import { useMemo } from 'react';

import { type QConfigStructure, type LevelItemWithLevel } from '../../types';

interface UseGetLevelItemsWithLevelInput {
  qConfigId: string | undefined;
  chapterData: QConfigStructure | undefined;
}

export function useGetLevelItemsWithLevel(input: Readonly<UseGetLevelItemsWithLevelInput>) {
  const { qConfigId, chapterData } = input;

  const { data, loading: isLoading } = useGetLevelItemSubtreeByQConfigStructureQuery({
    variables: { input: { qConfigId: qConfigId ?? '', qConfigStructureId: chapterData?.id ?? '' } },
    skip: !qConfigId || !chapterData?.id,
    fetchPolicy: 'network-only',
  });

  const levelItemsWithLevel = useMemo(
    () =>
      (data?.excGetQConfigChapter.levelItemSubtree ?? []).filter(
        (item): item is LevelItemWithLevel => item.level !== null,
      ),
    [data],
  );

  return { levelItemsWithLevel, isLoading };
}
